import IndexTableFolderRow from 'SalesContentIndexUI/components/IndexTableFolderRow';
import IndexTableRowCellSlot from 'SalesContentIndexUI/slots/IndexTableRowCellSlot';
import { isMultiBrandEnabled } from 'documents-lib/js/utils/isMultiBrandEnabled';
import DocumentOwnerCell from './DocumentOwnerCell';
import DocumentUpdatedAtCell from './DocumentUpdatedAtCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentsFolderRow = ({
  searchResult,
  selectionData,
  setSelectedFolder,
  toggleFolderSelection
}) => {
  return /*#__PURE__*/_jsxs(IndexTableFolderRow, {
    searchResult: searchResult,
    selectionData: selectionData,
    setSelectedFolder: setSelectedFolder,
    toggleFolderSelection: toggleFolderSelection,
    children: [/*#__PURE__*/_jsx(IndexTableRowCellSlot, {}), /*#__PURE__*/_jsx(IndexTableRowCellSlot, {}), /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
      children: /*#__PURE__*/_jsx(DocumentOwnerCell, {
        searchResult: searchResult
      })
    }), isMultiBrandEnabled() && /*#__PURE__*/_jsx(IndexTableRowCellSlot, {}), /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
      children: /*#__PURE__*/_jsx(DocumentUpdatedAtCell, {
        searchResult: searchResult
      })
    })]
  });
};
export default DocumentsFolderRow;